/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Composer from 'cio/components/action-composer/base';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { tagName } from '@ember-decorators/component';

export const MIN_LIMIT = 1;
export const MAX_LIMIT = 20;

const EDITABLE_KEYS = ['asc', 'collection', 'conditions', 'randomize', 'singleResult', 'limit', 'orderBy'];
@tagName('')
export default class AttributeUpdate extends Composer {
  @service store;

  previewObserverKeys = [`action.{${EDITABLE_KEYS.join(',')}}`];
  previewURL = 'collections/query'; // the url for the collection query

  originalCollectionId = undefined;
  visibleColumns = undefined;

  get action() {
    return this.editableEntity.action;
  }

  @computed('editableEntity.action.{hasDirtyAttributes,collection}', 'originalCollectionId')
  get isDirty() {
    return this.action.hasDirtyAttributes || this.action.get('collection.id') !== this.originalCollectionId;
  }
  get collectionSchema() {
    return this.action.get('collection.schema') ?? [];
  }
  get collections() {
    return this.store.peekAll('collection');
  }
  get hasLimitError() {
    let { limit } = this.action;
    return limit && (limit < MIN_LIMIT || limit > MAX_LIMIT);
  }
  get isInvalid() {
    return this.hasLimitError || this.action.errorsMap.attributeName;
  }
  get saveTooltipContent() {
    if (this.hasLimitError) {
      return `Limit must be between ${MIN_LIMIT} and ${MAX_LIMIT}.`;
    }

    return null;
  }

  getPreviewData() {
    return { action: this.action.serialize() };
  }

  cacheOriginalRelationships() {
    this.set('originalCollectionId', this.action.get('collection.id'));
  }

  saveTask = task({ restartable: true }, async () => {
    try {
      await this.onSave();
      this.cacheOriginalRelationships();
    } catch {
      // handled onSave
    }
  });

  @action
  rollback() {
    this.action.rollbackAttributes();

    this.action.set(
      'collection',
      this.originalCollectionId ? this.store.peekRecord('collection', this.originalCollectionId) : undefined,
    );

    this.onRollback();
  }

  @action
  setCollection(collection) {
    this.action.set('collection', collection);
    this.updateColumns(collection.schema.slice(0, 5));
  }

  @action
  updateColumns(columns) {
    this.action.set('queryPreviewColumns', columns);
    this.set('visibleColumns', columns);
  }

  init() {
    super.init(...arguments);

    this.cacheOriginalRelationships();

    let visibleColumns = [];

    if (this.action.queryPreviewColumns.length > 0) {
      visibleColumns = [...this.action.queryPreviewColumns];
    } else {
      // if no selection has been persisted, grab the first five schema items
      visibleColumns = this.collectionSchema.slice(0, 5);
    }

    this.set('visibleColumns', visibleColumns);
  }
}
